export const Source = {
  // TODO da togliere
  DATE_ALERT: 'DATE_ALERT',
  ACTIVITY_ALERT: 'ACTIVITY_ALERT',
  EQUIPMENT_ALERT: 'EQUIPMENT_ALERT',
  CHEMICAL_ALERT: 'CHEMICAL_ALERT',
  PATHOGEN_ALERT: 'PATHOGEN_ALERT',
  XSENSE_ALERT: 'XSENSE_ALERT',
  WAREHOUSE_ALERT: 'WAREHOUSE_ALERT',
  LOAD_ALERT: 'LOAD_ALERT',
  SATELLITE_ALERT: 'SATELLITE_ALERT',
  IRRIGATION_ALERT: 'IRRIGATION_ALERT',
  DISEASE_ALERT: 'DISEASE_ALERT',
  INSECTS_ALERT: 'INSECTS_ALERT',
  // TODO Nuove label e rules
  FIELD_ACTIVITY_TYPE: 'FieldActivityType',
  FIELD_ACTIVITY_DONE: 'FieldActivityDone',
  FIELD_ACTIVITY_AUTHORIZATION: 'FieldActivityTechAuthorization',
  FIELD_ACTIVITY_PHENOLOGICAL_STAGE: 'FieldActivityPhenologicalStage',
  FIELD_ACTIVITY_PRODUCT_NAME: 'FieldActivityProductName',
  FIELD_ACTIVITY_PRODUCT_BIO_USE: 'FieldActivityProductBioUse',
  FIELD_ACTIVITY_PRODUCT_REVOKED: 'FieldActivityProductRevoked',
  FIELD_ACTIVITY_USERS: 'FieldActivityAllUsers',
  FIELD_ACTIVITY_FIELDS: 'FieldActivityAnyFields',
  // Promemoria
  MEMO_EXPIRATION: 'MemoExpiration',
  // Devices
  DEVICE_LONG_PARAMETER: 'DeviceLongParameter',
  DEVICE_DOUBLE_PARAMETER: 'DeviceDoubleParameter',
  // COntainer
  CONTAINER_BALANCE: 'ContainerBalance',
  // Equipment
  EQUIPMENT_INSPECTION_DATE: 'EquipmentInspectionDate',
  EQUIPMENT_TECHNICAL_CHECK_DATE: 'EquipmentTechnicalCheckDate',
  // Load
  LOAD_QUANTITY: 'LoadQuantity',
  // Satelliti
  SATELLITI_MEAN_VARIATION: 'SpaceSenseSatelliteMeanVariation',
  SATELLITI_MEAN: 'SpaceSenseSatelliteMean',
  IRRIGATION_ADVICE_TRUE: 'IrrigationAdviceTrue',
  DISEASE_PROTECTION: 'DiseaseProtection',
  DISEASE_RISK: 'DiseaseRisk',
  EQUIPMENT_TASK_SEND: 'EquipmentTaskSend',
  EQUIPMENT_TASK_RECEIVED: 'EquipmentTaskReceived',
  EQUIPMENT_GEOFENCINGIN: 'EquipmentGeofencingIn',
  EQUIPMENT_GEOFENCINGOUT: 'EquipmentGeofencingOut',
};
